import RestPromise from "../../utils/RestPromise";
import {
  TAccountPayload,
  TOnboardingPayload,
  TServerProgress,
  TVersionChoice,
} from "./OnboardingRules";

/** Whether an email is new, has an account, or has a school one: never why. */
export type TEmailCheckResponse = { status: "new" | "exists" | "school" };
export type TAccountResponse = { email: string };
export type TCompleteResponse = { redirectUrl: string };

/**
 * The family onboarding's server side: whether an email is known and on which side, the version a
 * school account picks, the email for an account that is not the visitor's, the account once the
 * password is typed, where the page is, and the family at the end.
 */
export default class OnboardingApi {
  constructor(
    private readonly emailUrl: string,
    private readonly versionChoiceUrl: string,
    private readonly accountUrl: string,
    private readonly progressUrl: string,
    private readonly completeUrl: string,
    /** The login popup's « Ce n'est pas votre compte? »; the onboarding page has none */
    private readonly notMineUrl = "",
  ) {}

  public CheckEmail(email: string): Promise<TEmailCheckResponse> {
    return RestPromise.Create<TEmailCheckResponse>(this.emailUrl, "POST", {
      email,
    });
  }

  /** The server keeps the choice for the login that follows. */
  public ChooseVersion(email: string, choice: TVersionChoice): Promise<object> {
    return RestPromise.Create<object>(this.versionChoiceUrl, "POST", {
      email,
      choice,
    });
  }

  /** The choice no longer stands: the popup was left or the email changed. */
  public ForgetVersion(): Promise<object> {
    return RestPromise.Create<object>(this.versionChoiceUrl, "DELETE");
  }

  /** The server mails the address; the answer is the same whatever its account. */
  public NotMyAccount(email: string): Promise<object> {
    return RestPromise.Create<object>(this.notMineUrl, "POST", { email });
  }

  public CreateAccount(payload: TAccountPayload): Promise<TAccountResponse> {
    return RestPromise.Create<TAccountResponse>(
      this.accountUrl,
      "POST",
      payload,
    );
  }

  public SaveProgress(progress: TServerProgress): Promise<object> {
    return RestPromise.Create<object>(this.progressUrl, "PUT", progress);
  }

  public Complete(payload: TOnboardingPayload): Promise<TCompleteResponse> {
    return RestPromise.Create<TCompleteResponse>(
      this.completeUrl,
      "POST",
      payload,
    );
  }
}
